import { useStrings } from "@/i18n/LocaleContext";

export function Progress({ current, total }: { current: number; total: number }) {
  const t = useStrings();
  const pct = total > 0 ? Math.min(100, Math.round((current / total) * 100)) : 0;
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          color: "var(--color-muted)",
          fontSize: "0.8125rem",
          marginBottom: "0.375rem",
          maxWidth: "var(--max-content)",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <span>{t.question}</span>
        <span>{`${current} / ${total}`}</span>
      </div>
      <div
        style={{
          height: 4,
          background: "var(--color-subtle)",
          borderRadius: 9999,
          overflow: "hidden",
          maxWidth: "var(--max-content)",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div style={{ width: `${pct}%`, height: "100%", background: "var(--color-accent)", borderRadius: 9999 }} />
      </div>
    </div>
  );
}
